const sfs_stats = {
    init: () => {
  
  
        if ($('.shopify-section .sfs-stats')[0]) {
    
            $('.shopify-section .sfs-stats').each(function() {
                let section_id = $(this).data('section-id');
                let parent = `.sfs-stats[data-section-id="${section_id}"]`;

                const offsetStats = document.querySelectorAll(`${parent} [carbon-offset-stat]`);
                fetch('https://merchant.ecocart.io/merchant/lsg-dev02.myshopify.com')
                    .then((e)=>{ return e.json() })
                    .then((data) => {
                        const MULTIPLY_KG_TO_LB = 2.20462;
                        const statVal = data.stats.merchant.all_time.carbon_offset * MULTIPLY_KG_TO_LB;
                        offsetStats.forEach(offsetStat => {
                            offsetStat.setAttribute(`data-stat`, statVal / 1000000);
                        });
                        initCounters(parent);
                    });
            });

            function roundToTwo(num) {
                return +(Math.round(num + "e+2")  + "e-2");
            }

            function initCounters(parent) {
                
                const 
                      countersEl    = document.querySelector(`${parent} [sfs-stats-wrapper]`),
                      counters      = document.querySelectorAll(`${parent} [sfs-stats-number]`),
                      time          = 5, // seconds
                      rate          = 10; // updates per second
                
                function animateCounters(counter) {
                        const animate = () => {
                            const value = +counter.getAttribute('data-stat');
                            const data = +counter.getAttribute('data-progress');

                            let result;
                            
                            const increment = (value / time) / rate;
                            if(data < value) {
                                if (counter.getAttribute('sfs-round') === "true") {
                                    result = roundToTwo(data + increment);
                                } else {
                                    result = Math.ceil(data + increment);
                                }
                                setTimeout(animate, 1000 / rate);
                            } else {
                                if (counter.getAttribute('sfs-round') === "true") {
                                    result = roundToTwo(value);
                                } else {
                                    result = value;
                                }
                            }

                            counter.setAttribute('data-progress', result);
                            counter.innerText = result.toLocaleString();
                        }
                        animate();
                }

                counters.forEach(counter => {

                    const observer = new IntersectionObserver((entries, observer) => {
                        if (!entries[0].isIntersecting) return;
                        animateCounters(counter);
                    }, {threshold: 1});

                    observer.observe(counter);
                });
            }

        }
  
  
    }
};
export default sfs_stats;